import { useState } from 'react'

import {
    getMessageTemplates,
    IMessageTemplate,
    updateMessageTemplate,
} from '../../api/messageTemplates'
import useApiCall from '../../api/useApiCall'
import LoadingSection from '../LoadingSection/LoadingSection'

import { MessageTemplateContent } from './MessageTemplateContent'
import { MessageTemplateList } from './MessageTemplateList'

import styles from './MessageTemplates.module.scss'

export const MessageTemplates = () => {
    const [selectedMessageTemplate, setSelectedMessageTemplate] =
        useState<IMessageTemplate | null>(null)

    const handleUpdateSelection = (
        fetchedMessageTemplates: IMessageTemplate[]
    ) => {
        if (selectedMessageTemplate) {
            const updatedSelectedTemplate = fetchedMessageTemplates.find(
                (template) => template.id === selectedMessageTemplate.id
            )
            setSelectedMessageTemplate(updatedSelectedTemplate || null)
        }
    }

    const [{ data: messageTemplatesData, loading }, { refetch }] = useApiCall(
        getMessageTemplates,
        handleUpdateSelection
    )

    const handleSaveMessageTemplate = async (
        updatedTemplate: IMessageTemplate
    ) => {
        try {
            await updateMessageTemplate(updatedTemplate.key, updatedTemplate)
            await refetch()
        } catch (error) {
            console.error('Error updating message template:', error)
        }
    }

    return (
        <main className={styles.templates}>
            <div className={styles.templates__header}>
                <h1 className={styles.templates__header__title}>FAQ</h1>
            </div>

            <div className={styles.templates__items}>
                {loading ? (
                    <LoadingSection />
                ) : (
                    messageTemplatesData && (
                        <MessageTemplateList
                            messageTemplates={messageTemplatesData}
                            selectedMessageTemplate={selectedMessageTemplate}
                            onSelectMessageTemplate={setSelectedMessageTemplate}
                        />
                    )
                )}
            </div>
            <div className={styles.templates__responses}>
                {selectedMessageTemplate && (
                    <MessageTemplateContent
                        key={selectedMessageTemplate.id}
                        messageTemplate={selectedMessageTemplate}
                        onSave={handleSaveMessageTemplate}
                    />
                )}
            </div>
        </main>
    )
}
